var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":"Current users"}},_vm._l((_vm.people),function(item){return _c('b-list-group',{key:item.id,attrs:{"variant":"bg-transparent"}},[_c('b-list-group-item',[_vm._v(" "+_vm._s(item)+" ")])],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }